/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Payment_PendingInputs */



/**
* | output |
* | --- |
* | "Pending" |
*
* @param {Payment_PendingInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const payment_pending = /** @type {((inputs?: Payment_PendingInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Payment_PendingInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("En attente")
	if (locale === "es") return /** @type {LocalizedString} */ ("Pendiente")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Pendente")
	if (locale === "it") return /** @type {LocalizedString} */ ("In attesa")
	return /** @type {LocalizedString} */ ("Pending")
});